"use strict";

exports.__esModule = true;
exports.default = void 0;

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setBreakPoint = function setBreakPoint(value) {
  return _breakpoints.default[value];
};

var _default = setBreakPoint;
exports.default = _default;